<template>
  <layout-content>
    <recipients-modal-create-edit-form />
  </layout-content>
</template>

<script>
  import RecipientsModalCreateEditForm from '@db/components/recipients/recipients-create-edit-form';
  export default {
    components: { RecipientsModalCreateEditForm }
  };
</script>
